module.exports = __webpack_public_path__ + "static/media/subscription.4d268e3f.png";